module.exports = __webpack_public_path__ + "static/img/5.5345dc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/5.png
// module id = Cu/r
// module chunks = 0